module.exports = __webpack_public_path__ + "static/media/zodiac-sagittarius.cf21ded6.png";